import { useContext } from 'react';
import { AuthContext } from '../context/Auth.context';

const useAuth = () => useContext(AuthContext);
export default useAuth;
